import { Button } from "components/atoms";
import { MagellanPopups } from "components/molecules";
import { Form } from "components/organisms";
import {
  trackInitialValues,
  TrackTabs,
} from "components/organisms/forms/track/TrackForm";
import { useHasPermission } from "hooks";
import { useParamId } from "hooks/useParamId";
import middleware from "middleware";
import { PiPencilSimpleLine } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import { PopupActions } from "reactjs-popup/dist/types";
import { useDeleteTrack, useGetTrack } from "services/tracks";
import { getMainTitle } from "utils/global/mainTitle.utils";
import { getLastPathname } from "utils/navbar/getParentPathname";
import { onErrorShowToast } from "utils/service/errorHandler";

const Track = () => {
  const trackId = useParamId("track");
  const { pathname } = useLocation();

  const navigate = useNavigate();
  const hasPermission = useHasPermission();

  const removeTrack = useDeleteTrack(trackId);
  const { data: track, isLoading } = useGetTrack(trackId);

  const onRemoveTrack = async (actions: PopupActions) => {
    await removeTrack?.mutateAsync(undefined, {
      onError: (error) => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => {
        navigate("/track");
      },
    });
  };

  return (
    <Form.Track
      i18nextPrefix="track"
      initialValues={
        track ? middleware.track.queryToForm(track) : trackInitialValues
      }
      onSubmit={() => {}}
      tittle={getMainTitle(track?.mainTitle)}
      status={{ isLoading: isLoading, displayMode: true }}
      topbarContent={
        <div className="flex w-full justify-end items-center">
          {hasPermission('TrackPermissionsLIST**', 2) && (
            <Button
              isClear
              onlyIcon
            onClick={() => {
              track &&
                navigate(
                  `/track/edit/${trackId}/${getLastPathname(pathname)}`,
                  {
                    replace: true,
                  }
                );
            }}
          >
              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}
          {hasPermission('TrackPermissionsLIST**', 4) && (
            <MagellanPopups.DeleteWarning
              name={track?.mainTitle.title}
              onRemove={onRemoveTrack}
            />
          )}
        </div>
      }
    />
  );
};

export default Track;
